export default "__VITE_ASSET__9d873486__"